import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./PersonnelTypesUIHelpers";

const PersonnelTypesUIContext = createContext();

export function usePersonnelTypesUIContext() {
  return useContext(PersonnelTypesUIContext);
}

export const PersonnelTypesUIConsumer = PersonnelTypesUIContext.Consumer;

export function PersonnelTypesUIProvider({ personnelTypesUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openNewPersonnelTypePage: personnelTypesUIEvents.openNewPersonnelTypePage,
    openEditPersonnelTypePage: personnelTypesUIEvents.openEditPersonnelTypePage
  };

  return (
    <PersonnelTypesUIContext.Provider value={value}>
      {children}
    </PersonnelTypesUIContext.Provider>
  );
}